var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocLockerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5H54.5C54.5 14.5 62.5 14.5 62.5 22.5V54.5C62.5 54.5 62.5 62.5 54.5 62.5H10.5C10.5 62.5 2.5 62.5 2.5 54.5V22.5C2.5 22.5 2.5 14.5 10.5 14.5ZM42.5 12.5C42.5 9.84784 41.4464 7.3043 39.5711 5.42893C37.6957 3.55357 35.1522 2.5 32.5 2.5C29.8478 2.5 27.3043 3.55357 25.4289 5.42893C23.5536 7.3043 22.5 9.84784 22.5 12.5V14.5H42.5V12.5Z",
    stroke: "#077CA5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 38.5C30.5 40.6217 29.6571 42.6566 28.1569 44.1569C26.6566 45.6571 24.6217 46.5 22.5 46.5C20.3783 46.5 18.3434 45.6571 16.8431 44.1569C15.3429 42.6566 14.5 40.6217 14.5 38.5C14.5 36.3783 15.3429 34.3434 16.8431 32.8431C18.3434 31.3429 20.3783 30.5 22.5 30.5C24.6217 30.5 26.6566 31.3429 28.1569 32.8431C29.6571 34.3434 30.5 36.3783 30.5 38.5ZM30.5 38.5H50.5V44.5M42.5 38.5V42.5M18.5 14.5V22.5M18.5 62.5V54.5M46.5 14.5V26.5M46.5 62.5V54.5",
    stroke: "#077CA5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocLockerIcon);
export default __webpack_public_path__ + "static/media/DocLockerIcon.aa69b8db3186503fda7c053f522df398.svg";
export { ForwardRef as ReactComponent };